import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'employeeApplicationsPipe'
})
export class EmployeeApplicationsPipe implements PipeTransform {

  transform(recentApplications: string | null): string {

    let returnHtml = `<span class=\'font-weight-bolder text-left mgn-bottom-5 d-inline-block\'>Últimas postulaciones</span>`

    returnHtml += `<ul class=\'padding-left-15 text-left no-mgn\'>`

    if (recentApplications)
    {
      recentApplications.split(',').forEach(e => {
        returnHtml += '<li>' + e + '</li>'
      });
    }

    returnHtml += `</ul>`

    return returnHtml;
  }
}